import ReactDOM from 'react-dom/client';
import './index.less';
import App from './App';
import { BrowserRouter } from 'react-router';
import { initGA } from './ga4/ga4';
import ConnectionError from './components/errors/ConnectionError';

if (import.meta.env.VITE_HOSTING_LOCAL !== 'true') {
  const isSecure = window.location.protocol === 'https:';
  if (!isSecure && window.location.hostname !== 'localhost') {
    const targetURL = window.location.href.replace('http:', 'https:');
    window.location.replace(targetURL);
  }
}

window.initialPage = { pathname: window.location.pathname, search: window.location.search };

// Google Analytics / Google Tag Manager
initGA();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

const rootConnection = ReactDOM.createRoot(document.getElementById('root-connection'));
rootConnection.render(<ConnectionError />);
